import { initializeApp } from 'firebase/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyCqJdFKew6qakXpDwiBRlfUFa41SkR5AZM',
  authDomain: 'apt-data-ea5f8.firebaseapp.com',
  projectId: 'apt-data-ea5f8',
  storageBucket: 'apt-data-ea5f8.firebasestorage.app',
  messagingSenderId: '607372811233',
  appId: '1:607372811233:web:2b3cdc765786c002ae90a0',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export const authService = getAuth(app)
export const dbService = getFirestore()
export const storageService = getStorage()
